export const systemLogPermissionsConst = {
  view: {
    value: "view_systemlog",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu logów systemowych!",
  },
  add: {
    value: "add_systemlog",
    errorMsg: "Użytkownik nie ma uprawnień do dodania logów systemowych!",
  },
  update: {
    value: "change_systemlog",
    errorMsg: "Użytkownik nie ma uprawnień do edycji logów systemowych!",
  },
  delete: {
    value: "delete_systemlog",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania logów systemowych!",
  },
};

// The error messages mirror the old panel, which says "zmiennych" here too.
export const settingPermissionsConst = {
  view: {
    value: "view_setting",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu zmiennych!",
  },
  add: {
    value: "add_setting",
    errorMsg: "Użytkownik nie ma uprawnień do dodania zmiennych!",
  },
  update: {
    value: "change_setting",
    errorMsg: "Użytkownik nie ma uprawnień do edycji zmiennych!",
  },
  delete: {
    value: "delete_setting",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania zmiennych!",
  },
};

export const variablePermissionsConst = {
  view: {
    value: "view_variable",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu zmiennych!",
  },
  add: {
    value: "add_variable",
    errorMsg: "Użytkownik nie ma uprawnień do dodania zmiennych!",
  },
  update: {
    value: "change_variable",
    errorMsg: "Użytkownik nie ma uprawnień do edycji zmiennych!",
  },
  delete: {
    value: "delete_variable",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania zmiennych!",
  },
};

export const faqPermissionsConst = {
  view: {
    value: "view_faq",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu faq!",
  },
  add: {
    value: "add_faq",
    errorMsg: "Użytkownik nie ma uprawnień do dodania faq!",
  },
  update: {
    value: "change_faq",
    errorMsg: "Użytkownik nie ma uprawnień do edycji faq!",
  },
  delete: {
    value: "delete_faq",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania faq!",
  },
};

export const bannerPermissionsConst = {
  view: {
    value: "view_banner",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu banerów!",
  },
  add: {
    value: "add_banner",
    errorMsg: "Użytkownik nie ma uprawnień do dodania banerów!",
  },
  update: {
    value: "change_banner",
    errorMsg: "Użytkownik nie ma uprawnień do edycji banerów!",
  },
  delete: {
    value: "delete_banner",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania banerów!",
  },
};

// A CRM case - the list, the case form and closing the case.
export const clientcontactPermissionsConst = {
  view: {
    value: "view_clientcontact",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu spraw!",
  },
  add: {
    value: "add_clientcontact",
    errorMsg: "Użytkownik nie ma uprawnień do dodania spraw!",
  },
  update: {
    value: "change_clientcontact",
    errorMsg: "Użytkownik nie ma uprawnień do edycji spraw!",
  },
  delete: {
    value: "delete_clientcontact",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania spraw!",
  },
};

// Messages inside a CRM case - reading the conversation and replying to it.
export const messagesPermissionsConst = {
  view: {
    value: "view_clientcontactmessage",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu spraw!",
  },
  add: {
    value: "add_clientcontactmessage",
    errorMsg: "Użytkownik nie ma uprawnień do dodania spraw!",
  },
  update: {
    value: "change_clientcontactmessage",
    errorMsg: "Użytkownik nie ma uprawnień do edycji spraw!",
  },
  delete: {
    value: "delete_clientcontactmessage",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania spraw!",
  },
};
